import { DefaultLandingPage } from "../pages/DefaultLandingPage";
import * as React from "react";
export function Index() {
   return <DefaultLandingPage />;
}